import * as React from "react";
import { Card } from "./cards";

require('dotenv').config()

type State = {
	data: { name: string, link: string }[]
}

const API = process.env.REACT_APP_END_POINT === undefined ? "https://kidilansearch.herokuapp.com/" : process.env.REACT_APP_END_POINT;

export default class App extends React.Component<any, State> {

	search = async (event: any) => {
		let value = event.target.value;
		if (value === "" || value === undefined || value === null) {
			this.setState({ data: [] })
			return;
		}
		let res = await fetch(API + 'search/' + event.target.value);

		if (res.ok) {
			let data = await res.json();
			this.setState({
				data: data.result.map(function (rows: any, i: number) {
					return (
						<Card key={i} link={rows.link} name={rows.name} />
					)
				})
			})
		}
	}
	public render() {
		return (
			<>
				<main>
					<div className={"fixed"}>
						<h1>Kidilan Padam Search Engine</h1>
						<input type="text" onChange={this.search}  placeholder="&#x1F50D;"/>
						<br /><br />
					</div>
					<div className={"results"}>
						{this.state == null ? "" : this.state.data}
					</div>
				</main>
			</>
		);
	}
}
